import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const StageReferenceModal = ({refData = [], show, handleClose }) => {
    console.log("refData = ",refData);
    const [selectedImage, setSelectedImage] = useState(
        (refData.length > 0 && refData[0] && refData[0].image_path) ? refData[0].image_path : ''
    );
    const [showImage, setShowImage] = useState(true);
    useEffect(() => {
        if (refData.length > 0 && refData[0] && refData[0].image_path) {
            setSelectedImage(refData[0].image_path);
        } else {
            setSelectedImage('');
        }
    }, [refData]);
    const handleImageClick = (imageSrc) => {
        setShowImage(false);
        setTimeout(() => {
            setSelectedImage(imageSrc);
            setShowImage(true);
        }, 500);
    };
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>SHOW STAGE REFERENCE DESIGNS DATA</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {refData.length > 0 ? (
                    <>
                        <div className={`image-container ${showImage ? 'show' : 'hide'} mt-4`}>
                            {selectedImage && (
                                <div>
                                    <img src={selectedImage} alt="Selected Exhibition" className="img-fluid" />
                                </div>
                            )}
                        </div>
                        <p>
                            {refData.map((item, index) => (
                                item.image_path ? (
                                    <span key={index} onClick={() => handleImageClick(item.image_path)} className="image-thumbnail">
                                        <img src={item.image_path} alt={`Exhibition ${index + 1}`} width="80" height="80" style={{ cursor: 'pointer', margin: '5px', borderRadius: '5px' }} />
                                    </span>
                                ) : null
                            ))}
                        </p>
                    </>
                ) : (
                    <p>No Stage Reference Available!!!</p>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default StageReferenceModal;
